import router from '@/router'
import { forEach } from 'lodash'

/**
 * This method finds state for the route with the given name
 *
 * @param Object state
 * @return undefined|Object
 */
const getStateByRouteName = (state) => (routeName) => {
  let matchedState

  forEach(state, function (vueRouteState, vueRouteName) {
    if (routeName === vueRouteName) {
      matchedState = vueRouteState
      return true
    }
  })

  return matchedState
}

/**
 * I considered whether or not I should be storing state based on route name,
 * path, etc... The current implementation uses the route name(e.g.
 * route-dashboard or vehicle-index). This way regardless of the path we can
 * persist and restore state(e.g. the route-dashboard is resolvable at routes/
 * and routes/dashboard). I am not confident if this is the right way to go but
 * we can always change it later.
 */
export default {
  /**
   * Represents key value pairs of names routes and state that should be loaded
   * when the route is loaded e.g. { 'vehicle-list': {pageNumber: 10} }
   */
  state: {},

  getters: {
    hasState: state => {
      return getStateByRouteName(state) != null
    },
    getStateByRouteName: state => {
      return getStateByRouteName(state)
    }
  },
  mutations: {
    setState (vuexState, routeState) {
      vuexState[routeState.routeName] = routeState.state
    }
  },
  actions: {

    /**
     * Persists the routeState for the named route
     *
     * @param Object context vuex state container
     * @param Any data to be persisted (e.g.vehicle-create)
     */
    setState (context, payload) {
      const routeName = payload.$routeName || router.currentRoute.name
      delete payload.$routeName
      context.commit('setState', { routeName: routeName, state: payload })
    }
  }
}
